import React from 'react'
import styled from 'styled-components'
import { color } from 'core/theme'

const SwmButton = styled.button`
    background: none;
    cursor: pointer;
    display: flex;
    text-align: center;
    font-weight: 400;
    height: 100px;
    width: 100%;
    transition: all 300ms ease-out;
    color: white !important;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    background: ${color('textAlt')};
    &:hover {
        background: ${color('backgroundAlt')};
    }
`

export default SwmButton
